// extracted by mini-css-extract-plugin
export default {"card":"Card_card__eTYIl","fade":"Card_fade__7wFUH","full-width":"Card_full-width__JK7Bn"};